import { CUSTOMER_EDITING, FETCH_CUSTOMER } from '../actions/CustomerActions';

// INITIALIZE STATE
const initialState = {
    customer: null,
    fetching: false,
    fetched: false,
    failed: false,
    isEditing: false,
};

// REDUCER
export const CustomerReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSTOMER}_PENDING`:
            return {
                ...state,
                customer: null,
                fetching: true,
                fetched: false,
                failed: false,
                isEditing: false,
            };
        case `${FETCH_CUSTOMER}_FULFILLED`:
            return {
                ...state,
                customer: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
                isEditing: false,
            };
        case `${FETCH_CUSTOMER}_REJECTED`:
            return {
                ...state,
                customer: null,
                fetching: false,
                fetched: false,
                failed: true,
                isEditing: false,
            };
        case CUSTOMER_EDITING:
            return {
                ...state,
                isEditing: action.payload,
            };
        default:
            return state;
    }
};
